<!-- FILE GENERATED BY packages/components/design-tokens/build-scripts/generate-icons.js DO NOT CHANGE -->

<svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    data-token-name="IconCalendar_24"
    viewBox="0 0 24 24"
    aria-hidden="true"
>
    <path
        fill="currentColor"
        fill-rule="evenodd"
        d="M15 2.366V2.09C15 .936 15.895 0 17 0h.2c1.105 0 2 .936 2 2.09v.276h.8c1.1 0 2 .928 2 2.063v16.508C22 22.07 21.1 23 20 23H4c-1.1 0-2-.928-2-2.063V4.429c0-1.135.9-2.063 2-2.063h1V2.09C5 .936 5.895 0 7 0h.2c1.105 0 2 .936 2 2.09v.276H15Zm5 18.57H4V7.525h16v13.413Z"
        clip-rule="evenodd"
    />
</svg>
